import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { PAGE_HEADER_VERSION_CONFIG } from '../../../../layout/page/header/page-header.config';
import { NProductLayout } from './product-layout.interface';

export const PRODUCT_LAYOUT_CONFIG: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: 'cms-product-layout',
    onDemandOnly: true,
    block: {
        url: 'cms-product-layout'
    },
    name: 'Product page layout',
    description: 'Product page layout block',
    fields: [
        // Media gallery
        {
            key: '_label-gallery',
            type: NICmsContentField.EFieldType.label,
            title: 'Media gallery'
        },
        <NICmsContentField.IChoiceField>{
            key: 'mediaLayout',
            type: NICmsContentField.EFieldType.choice,
            title: 'Media layout',
            description: 'Select the media layout',
            options: [
                {
                    key: NProductLayout.EMediaLayout.scroll,
                    value: 'Scroll'
                },
                {
                    key: NProductLayout.EMediaLayout.grid,
                    value: 'Grid'
                }
            ],
            default: NProductLayout.EMediaLayout.scroll
        },
        {
            key: 'requiredMediaLabels',
            type: NICmsContentField.EFieldType.text,
            title: 'Whitelisted media roles',
            description: 'Comma separated. If set then only media items with these labels/roles will be shown'
        },
        {
            key: 'bannedMediaLabels',
            type: NICmsContentField.EFieldType.text,
            title: 'Blacklisted media roles',
            description: 'Comma separated. If set media items with these labels/roles will be skipped'
        },
        <NICmsContentField.IComponentsField>{
            key: 'bottomComponents',
            type: NICmsContentField.EFieldType.components,
            title: 'Bottom Components',
            itemName: 'component',
            default: []
        },
        ...PAGE_HEADER_VERSION_CONFIG.filter(field => field.key !== 'headerHideUp'),
        <NICmsContentField.IField>{
            key: '_label-other',
            type: NICmsContentField.EFieldType.label,
            title: 'Other'
        },
        <NICmsContentField.IToggleField>{
            key: 'allowFinancingTray',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Allow financing tray',
            default: false,
            labels: {
                true: 'Yes',
                false: 'No'
            }
        },
        {
            key: '_label-details',
            type: NICmsContentField.EFieldType.label,
            title: 'Product details'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'detailsAttributes',
            title: 'Product details',
            itemName: 'section',
            itemNameField: 'heading',
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    title: 'Heading',
                    key: 'heading',
                    default: 'Lorem ipsum'
                },
                <NICmsContentField.IToggleField>{
                    key: 'bulletPoints',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Prepend bullet point',
                    default: false,
                    labels: {
                        true: 'Yes',
                        false: 'No'
                    }
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'attributes',
                    title: 'Attributes',
                    itemName: 'Attribute',
                    itemNameField: 'code',
                    fields: [
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Type',
                            key: 'type',
                            options: [
                                { key: 'attribute', title: 'Select Attribute' },
                                { key: 'property', title: 'Attribute Code' }
                            ],
                            default: 'attribute'
                        },
                        <NICmsContentField.IRelationField>{
                            key: 'code',
                            type: NICmsContentField.EFieldType.relation,
                            title: 'Select Attribute',
                            options: {
                                title: 'Attribute',
                                type: 'attribute',
                                qty: 1
                            },
                            canShow: data => data.type === 'attribute'
                        },
                        {
                            key: 'codeManual',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Attribute Code',
                            canShow: data => data.type === 'property'
                        },
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Display mode',
                            key: 'mode',
                            options: [
                                { key: 'attributeValue', title: 'Attribute values only (Blue)' },
                                { key: 'attributeTitleValue', title: 'Attribute labels and value (Color: Blue)' },
                                { key: 'cms', title: 'CMS block' }
                            ],
                            default: 'attribute'
                        }
                    ]
                }
            ],
            default: []
        },
        {
            key: '_label-furniture',
            type: NICmsContentField.EFieldType.label,
            title: 'Furniture details'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'dimensionsAttributes',
            title: 'Dimensions',
            itemName: 'section',
            itemNameField: 'heading',
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    title: 'Heading',
                    key: 'heading',
                    default: 'Lorem ipsum'
                },
                <NICmsContentField.IToggleField>{
                    key: 'bulletPoints',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Prepend bullet point',
                    default: false,
                    labels: {
                        true: 'Yes',
                        false: 'No'
                    }
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'attributes',
                    title: 'Attributes',
                    itemName: 'Attribute',
                    itemNameField: 'code',
                    fields: [
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Type',
                            key: 'type',
                            options: [
                                { key: 'attribute', title: 'Select Attribute' },
                                { key: 'property', title: 'Attribute Code' }
                            ],
                            default: 'attribute'
                        },
                        <NICmsContentField.IRelationField>{
                            key: 'code',
                            type: NICmsContentField.EFieldType.relation,
                            title: 'Select Attribute',
                            options: {
                                title: 'Attribute',
                                type: 'attribute',
                                qty: 1
                            },
                            canShow: data => data.type === 'attribute'
                        },
                        {
                            key: 'codeManual',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Attribute Code',
                            canShow: data => data.type === 'property'
                        },
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            title: 'Display mode',
                            key: 'mode',
                            options: [
                                { key: 'attributeValue', title: 'Attribute values only (Blue)' },
                                { key: 'attributeTitleValue', title: 'Attribute labels and value (Color: Blue)' },
                                { key: 'cms', title: 'CMS block' }
                            ],
                            default: 'attribute'
                        }
                    ]
                }
            ],
            default: []
        },
        {
            key: '_label-gift-boxing',
            type: NICmsContentField.EFieldType.label,
            title: 'Gift boxing'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'giftBoxing',
            title: 'Gift boxing',
            itemName: 'copy',
            fields: [
                {
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'copy',
                    title: 'Gift boxing copy'
                }
            ]
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'giftBoxingImage',
            title: 'Gift Boxing Image'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: '_label-information',
            title: 'Return information'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'returnNote',
            title: 'Return note'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'returnLinkText',
            title: 'Return link text'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'returnLink',
            title: 'Return link'
        }
    ]
};
